import { render, staticRenderFns } from "./ProjectBurnSummary.vue?vue&type=template&id=022733c2"
import script from "./ProjectBurnSummary.vue?vue&type=script&lang=js"
export * from "./ProjectBurnSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports